// Component: Accordion
// Author: Tejaswini
import AccordionNPM from '@rotaryintl/harris-accordion';
import { Text, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { useState } from 'react';
import VendorsCard from '../VendorsCard';
import i18n from 'i18next';
 
const Accordion = (props) => {
  const [activeId, setActiveId] = useState(null);
 
  const handleToggle = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
 
  const AccordionData = props.fields?.children?.map((items, index) => {
    return {
      key: index,
      id: items?.fields?.ComponentId,
      active: activeId === items?.fields?.ComponentId,
      handleToggle: () => handleToggle(items?.fields?.ComponentId),
      title: <Text field={items?.fields?.Title} />,
      subTitle: <Text field={items?.fields?.Subtitle} />,
      text: (
        <>
          <RichText field={items.fields?.Text} />
          {items?.fields?.children?.map((child) => {
            child.fields.PhoneLabel = i18n.t('VendorsCardPhone',{DefaultValue:'Phone'});
            child.fields.FaxLabel = i18n.t('VendorsCardFax',{DefaultValue:'Fax'});
            child.fields.WebsiteLabel = i18n.t('VendorsCardWebsite',{DefaultValue:'Website'});
            child.fields.EmailLabel = i18n.t('VendorsCardEmail',{DefaultValue:'Email'});
            child.fields.MerchandiseLabel = i18n.t('VendorsCardMerchandise',{DefaultValue:'Merchandise'});
            return <VendorsCard key={child.id} fields={child.fields} />;
          })}
        </>
      ),
      disabled: items?.fields?.IsDisabled?.value,
    };
  });
 
  return (
    <>
      <AccordionNPM items={AccordionData} />
    </>
  );
};
 
export default withSitecoreContext()(Accordion);
